<template>
  <div class="relative w-$portalContainerWidth mx-auto mt-20px h-[calc(100vh-180px)]">
    <NavigationBarProps></NavigationBarProps>
    <el-card class="w-full mr-10px h-[calc(100%-50px)]" :body-style="{ height: '100%' }">
      <el-input
        size="small"
        clearable
        placeholder="搜索应用名称"
        class="!w-200px mr-10px"
        v-model="search.name"
      />
      <el-select
        v-model="search.type"
        size="small"
        placeholder="应用类型"
        filterable
        clearable
        class="mr-10px"
      >
        <el-option
          v-for="item in typeList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="findList">搜索</el-button>
      <el-table height="calc(100% - 56px)" class="mt-20px" border :data="tableData">
        <el-table-column label="应用程序名称" width="330px" show-overflow-tooltip prop="name">
        </el-table-column>
        <el-table-column label="应用程序类型" show-overflow-tooltip prop="type"> </el-table-column>
        <el-table-column label="版本" prop="version"> </el-table-column>
        <el-table-column label="上传时间" prop="creationTime"> </el-table-column>
        <el-table-column label="操作" width="80px">
          <template slot-scope="scope">
            <el-button size="mini" @click="download(scope.row.url)">
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import NavigationBarProps from '../components/NavigationBarProps'

export default {
  name: 'AddressBook',
  components: {
    NavigationBarProps,
  },
  data() {
    return {
      typeList: [],
      tableData: [],
      search: {
        name: '',
        type: '',
      },
    }
  },
  computed: {},
  created() {
    const { config } = Wiz.globalSettings.dynamicModules.modules['portal-homepage']
    document.title = `资源中心 - ${config.title}`
    this.tableData = config.source
  },
  methods: {
    // 获取用户列表
    async findList() {},
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    download(url) {
      window.location.href = url
    },
  },
}
</script>

<style lang="scss" scoped></style>
